// referral-conversations-chart.tsx
import { AnalyticsChart } from "./analytics-chart";
import { MetricTerm }     from "../metric-term";
import { useReferralConversationsData } from "@/app/hooks/analytics/useReferralConversationsData";
import { getPerformanceEvents } from "@/app/data/performance-events";

interface Props {
  antennaData?:          any;
  selectedModels?:       string[];
  brandName?:            string;
  onNavigateToInsights?: () => void;
  projectionDate?:       string | null;
}

export function ReferralConversationsChart({ antennaData, selectedModels, brandName, onNavigateToInsights, projectionDate }: Props) {
  const { data, isLoading, error } = useReferralConversationsData("full", antennaData, selectedModels);
  const events = getPerformanceEvents(brandName);

  return (
    <AnalyticsChart
      timeSeriesData={data?.timeSeriesData ?? []}
      selectedModels={data?.selectedModels ?? []}
      isLoading={isLoading}
      error={error}
      metricUnit="%"
      metricName="Mention Rate"
      insightContext="mention rate"
      brandName={brandName}
      onNavigateToInsights={onNavigateToInsights}
      projectionDate={projectionDate}
      events={events}
      isIllustrative={data?.isSynthetic}
      incompleteRuns={data?.incompleteRuns}
      rebaselineMarks={data?.rebaselineMarks}
      metricTitle={
        <MetricTerm
          definition="The share of AI responses that name your brand at least once. This is the top of the funnel. It shows whether AI models know your brand exists in this category."
          calculation="Responses where your brand appears by name divided by total responses scored, averaged across the AI models measured in this run."
          interpretation="A high mention rate means broad AI awareness. If this is high but Primary Recommendation is low, the gap lives further down the funnel and is an encoding problem, not an awareness problem."
          goodRange="70% or higher is strong. 50-69% is competitive. Below 50% means the brand is not consistently surfaced and awareness-level content investment is the priority."
          onOpenAIChat={() => {}}
        >
          Mention Rate
        </MetricTerm>
      }
    />
  );
}